import React from 'react';
import { encodeQueryParams } from './query-params';
import { IconCalendarCheck, IconCalendarPlus, IconCalendarXmark, IconExchange } from '../components/ui-kit/icons';
import moment from 'moment';

export const DutyRequestIcon = ({ type }) => {
  const IconClass = {
    absence_request: IconCalendarXmark,
    extra_work_request: IconCalendarCheck,
    duty_exchange: IconExchange,
    duty_request: IconCalendarPlus
  }[type];

  const title = I18n.t(`activerecord.models.schedule/exchanges/${type}.one`);

  return <IconClass title={title} />;
};

export const openStates = ['open', 'resolvable', 'pending_counter_exchange', 'pending_approval'];

// This utility function creates a link to a duty transaction for a membership
export const linkToNewDutyTransaction = (type, membershipId, params) => {
  params = encodeQueryParams(params);
  return `/memberships/${membershipId}/schedule/exchanges/${type}/new?${params}`;
};

// This utility function creates a link to a duty transaction for a group
export const linkToNewGroupDutyTransaction = (type, groupId, params) => {
  params = encodeQueryParams(params);
  return `/groups/${groupId}/schedule/exchanges/${type}/new?${params}`;
};

// Returns the relative URL to a duty transaction. Supports absence_requests,
// duty_exchanges and duty_requests.
export const dutyTransactionPath = ({ type, id, group_id, membership_id }) => {
  if (type === 'absence_request' || type === 'duty_exchange' || type === 'extra_work_request') {
    return `/memberships/${membership_id}/schedule/exchanges/${type}s/${id}`;
  } else if (type === 'duty_request') {
    return `/groups/${group_id}/schedule/exchanges/duty_requests/${id}`;
  } else {
    throw new Error(`Not supported ${type}`);
  }
};

export const dutyTransactionHtmlLink = (transaction, text) => (
  <a href={dutyTransactionPath(transaction)} target="_blank" rel="noreferrer">
    {text}
  </a>
);

export const dtNearingCompletion = (time, dutyTransaction) => {
  if (!dutyTransaction.show_nearing_completion_warning_at) return false;
  return moment(time).isSameOrAfter(dutyTransaction.show_nearing_completion_warning_at);
};

// select only transactions that relate to the user:
// - requested absence requests
// - requested and offered duty exchanges
// - offered duty requests
export const isRegardingUser = (transaction, userId) => {
  const { user_id, duty_exchange_intervals, type } = transaction;
  const isRequester = user_id === userId;
  const wasRequested = (duty_exchange_intervals || []).find(ex => ex.user_id == userId);

  if (type === 'absence_request' || type === 'extra_work_request') {
    // user requested absence
    return isRequester;
  } else if (type === 'duty_exchange') {
    // user requested the duty exchange, or received it
    return isRequester || wasRequested;
  } else if (type === 'duty_request') {
    // user was requested to become available
    return wasRequested;
  } else {
    throw new Error(`Not supported ${type}`);
  }
};
